// Dependencies
require("webstrap/type");

// Copy images
require("!!asset!./img/arrow.svg");

// Styles
require("./next-page.scss");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/next-page/index.js
 ** module id = 96
 ** module chunks = 0 1
 **/